import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { PrimaryStyledLink } from '../styles';
import { useLinkBehavior } from '../shared';
var Link = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var dataTest = _ref['data-test'],
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      linkProps = _objectWithoutProperties(_ref, ["data-test", "size"]);

  var _useLinkBehavior = useLinkBehavior(linkProps),
      linkBehavior = _extends({}, _useLinkBehavior);

  return /*#__PURE__*/React.createElement(PrimaryStyledLink, _extends({
    size: size
  }, linkProps, linkBehavior, {
    ref: ref,
    "data-test": dataTest ? dataTest : undefined
  }));
});
Link.displayName = 'Link';
export default Link;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/link/dist/esm/variants/Link.js
// module id = 3341
// module chunks = 11